import Breadcrumb from "../components/Breadcrumb";
import TaxesLayer from "../components/TaxRateLayer";

const TaxRatePage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Tax Rates" />

      <TaxesLayer />
    </>
  );
};

export default TaxRatePage;
